export const SUPPORTED_COUNTRIES = {
  BRAZIL: 'BR',
  CANADA: 'CA',
  FRANCE: 'FR',
  GERMANY: 'DE',
  ITALY: 'IT',
  MEXICO: 'MX',
  ROMANIA: 'RO',
  SPAIN: 'ES',
  UKRAINE: 'UA',
  UNITED_STATES: 'US'
};

export const NORTH_AMERICAN_COUNTRIES = [
  SUPPORTED_COUNTRIES.UNITED_STATES,
  SUPPORTED_COUNTRIES.CANADA,
  SUPPORTED_COUNTRIES.MEXICO
];

export const isNorthAmerican = countryCode => NORTH_AMERICAN_COUNTRIES.includes(countryCode);

export const LATAM_COUNTRIES = {
  ARGENTINA: 'AR',
  BRAZIL: 'BR',
  PARAGUAY: 'PY',
  URUGUAY: 'UY'
};

export const LATAM_COUNTRY_CODES = [
  LATAM_COUNTRIES.ARGENTINA,
  LATAM_COUNTRIES.BRAZIL,
  LATAM_COUNTRIES.PARAGUAY,
  LATAM_COUNTRIES.URUGUAY
];

export const EU9_COUNTRIES = {
  BELGIUM: 'BE',
  BULGARIA: 'BG',
  CZECHIA: 'CZ',
  GREECE: 'GR',
  HUNGARY: 'HU',
  POLAND: 'PL',
  PORTUGAL: 'PT',
  TURKEY: 'TR',
  UNITED_KINGDOM: 'GB'
};

export const EU9_COUNTRY_CODES = [
  EU9_COUNTRIES.BELGIUM,
  EU9_COUNTRIES.BULGARIA,
  EU9_COUNTRIES.CZECHIA,
  EU9_COUNTRIES.GREECE,
  EU9_COUNTRIES.HUNGARY,
  EU9_COUNTRIES.POLAND,
  EU9_COUNTRIES.PORTUGAL,
  EU9_COUNTRIES.TURKEY,
  EU9_COUNTRIES.UNITED_KINGDOM
];

export const EMEA_COUNTRIES = [
  SUPPORTED_COUNTRIES.UKRAINE,
  SUPPORTED_COUNTRIES.ROMANIA,
  SUPPORTED_COUNTRIES.ITALY,
  SUPPORTED_COUNTRIES.FRANCE,
  SUPPORTED_COUNTRIES.GERMANY,
  SUPPORTED_COUNTRIES.SPAIN,
  EU9_COUNTRIES.HUNGARY,
  EU9_COUNTRIES.POLAND,
  EU9_COUNTRIES.TURKEY,
  EU9_COUNTRIES.UNITED_KINGDOM
];

export const EUROPE_LIMITED_COUNTRIES = [
  SUPPORTED_COUNTRIES.UKRAINE,
  SUPPORTED_COUNTRIES.ROMANIA,
  SUPPORTED_COUNTRIES.ITALY,
  SUPPORTED_COUNTRIES.FRANCE,
  SUPPORTED_COUNTRIES.GERMANY,
  SUPPORTED_COUNTRIES.SPAIN,
  EU9_COUNTRIES.HUNGARY,
  EU9_COUNTRIES.POLAND,
  EU9_COUNTRIES.UNITED_KINGDOM,
  EU9_COUNTRIES.PORTUGAL,
  EU9_COUNTRIES.TURKEY,
  EU9_COUNTRIES.BULGARIA,
  EU9_COUNTRIES.GREECE,
  EU9_COUNTRIES.CZECHIA,
  EU9_COUNTRIES.BELGIUM
];

export const isEu9Limited = (countryCode) => {
  return EUROPE_LIMITED_COUNTRIES.includes(String(countryCode).toUpperCase());
};

export const isEmeaCountry = countryCode => {
  return EMEA_COUNTRIES.includes(countryCode.toUpperCase());
};

export const isLatamCountry = countryCode => {
  return LATAM_COUNTRY_CODES.includes(countryCode.toUpperCase());
};

export const phase4Countries = {
  ARGENTINA: 'AR',
  PARAGUAY: 'PY',
  SOUTH_AFRICA: 'ZA',
  URUGUAY: 'UY'
};

export const phase4CountryCodes = Object.values(phase4Countries);

export const isPhase4Country = countryCode => phase4CountryCodes.includes(countryCode.toUpperCase());

const nonCommaDecimalLanguages = ['en-us', 'en-ca', 'fr-ca', 'en-gb', 'es-419', 'en'];

export const isCommaDecimalLang = locale => !nonCommaDecimalLanguages.includes(locale);

export const NO_DECIMAL_CURRENCY_CODES = [
  'HUF'
];

export const HYBRID_ONLY_COUNTRIES = [
  SUPPORTED_COUNTRIES.UKRAINE,
  SUPPORTED_COUNTRIES.ROMANIA,
  SUPPORTED_COUNTRIES.ITALY,
  SUPPORTED_COUNTRIES.FRANCE,
  SUPPORTED_COUNTRIES.GERMANY,
  SUPPORTED_COUNTRIES.SPAIN,
  SUPPORTED_COUNTRIES.BRAZIL,
  EU9_COUNTRIES.HUNGARY,
  EU9_COUNTRIES.POLAND,
  phase4Countries.ARGENTINA
];

const otherCountries = {
  MEXICO: 'MX'
};

export const countriesAllowDecimalInput = [
  SUPPORTED_COUNTRIES.FRANCE,
  SUPPORTED_COUNTRIES.GERMANY,
  SUPPORTED_COUNTRIES.ITALY,
  SUPPORTED_COUNTRIES.ROMANIA,
  SUPPORTED_COUNTRIES.SPAIN,
  SUPPORTED_COUNTRIES.UKRAINE,
  SUPPORTED_COUNTRIES.UNITED_STATES,
  ...Object.values(EU9_COUNTRIES),
  ...Object.values(phase4Countries),
  otherCountries.MEXICO
];

const SEASON_VARIABLE_COUNTRIES = [LATAM_COUNTRIES.BRAZIL];

export const isSeasonVariableCountry = (countryCode) => SEASON_VARIABLE_COUNTRIES.includes(countryCode);
